module.exports = __webpack_public_path__ + "img/icon-downloads.c5331cdc.svg";